import {
    //巡检tab栏完成查询
    checkSubDetail
} from "@/api/eva/index";
const eva = {
    state: {
        data:{
            active:false,
            device:false,
            problem:false,
            suggestion:false
        }
    },
    actions: {
        checkSubDetail(context){
            checkSubDetail({
                subId:JSON.parse(window.sessionStorage.getItem("subId")).id
            }).then((res)=>{
                context.commit('setData', res.data.data)
            })
        }
    },
    mutations: {
        setData(state,payload){
            state.data = payload;
            console.log(payload);
        }
    },
    getters: {

    },
    namespaced: true
}
export default eva